import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
export const StoriesSliders = {
    init() {
      const self = this;

      self.settings();

      if (self.pm) {
        self.pm.addPersonalizedContentLoaded(function () {
          self.storySlider();
          self.favStoriesSlider();
        });
      } else {
        self.storySlider();
        self.favStoriesSlider();
      }
    },
    settings() {
      this.storySliders = document.querySelectorAll(
        '.story-slider-wrap:not(.story-slider-wrap--favs):not(.swiper-initialized)',
      ) as NodeListOf<HTMLElement>;
      this.favSliders = document.querySelectorAll(
        '.story-slider-wrap--favs:not(.swiper-initialized)',
      ) as NodeListOf<HTMLElement>;
      // @ts-ignore
      this.pm = window.personalizationManager;
    },
    storySlider() {
      const self = this;

      self.storySliders.forEach((wrap) => {
        const controls = wrap.querySelector('.story-slider-controls') as HTMLElement;
        const prev = controls.querySelector('.swiper-button-prev') as HTMLButtonElement;
        const next = controls.querySelector('.swiper-button-next') as HTMLButtonElement;

        new Swiper(wrap, {
          modules: [Navigation],
          slidesPerView: 'auto',
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: next,
            prevEl: prev,
          },
          breakpoints: {
            768: {
              spaceBetween: 40,
              centeredSlides: true,
            },
          },
        });
      });
    },
    favStoriesSlider() {
      const self = this;

      self.favSliders.forEach((wrap) => {
        const controls = wrap.querySelector('.story-slider-controls') as HTMLElement;
        const prev = controls.querySelector('.swiper-button-prev') as HTMLButtonElement;
        const next = controls.querySelector('.swiper-button-next') as HTMLButtonElement;

        new Swiper(wrap, {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: next,
            prevEl: prev,
          },
          breakpoints: {
            768: {
              spaceBetween: 40,
              slidesPerView: 2,
            },
            1024: {
              spaceBetween: 40,
              slidesPerView: 3,
            },
            1280: {
              spaceBetween: 40,
              slidesPerView: 4,
            },
          },
        });
      });
    },
  };

(function () {
  

  StoriesSliders.init();
})();
